var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.__existFlag)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.__show),expression:"__show"}],class:_vm.__class,attrs:{"id":_vm._comId}},[(_vm.getUrl)?_c('jgp-panel',{attrs:{"_url":_vm.getUrl,"_onload":_vm.onload}}):_vm._e(),(!_vm.getUrl)?_c('jgp-panel',{attrs:{"_onload":_vm.onload}},[_vm._t("default")],2):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }